import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { Permission } from '@/models/user';
import { CashDesksContent } from '@/pageContents/cashDesks/CashDesksContent';

const CashDesksPage: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Kassen | Starjack Backoffice</title>
            </Helmet>

            <CashDesksContent />
        </>
    );
};

CashDesksPage.isProtected = true;
CashDesksPage.permissions = [Permission.ADMIN];
CashDesksPage.getLayout = (Component) => (
    <SidebarLayout>{Component}</SidebarLayout>
);

export default CashDesksPage;
